import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get documentSeries
export const getDocumentSeries = createAsyncThunk(
  "documentSeries/getDocumentSeries",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getDocumentSeries({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all documentSeries
export const getAllDocumentSeries = createAsyncThunk(
  "documentSeries/getAllDocumentSeries",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllDocumentSeries();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("documentSeries/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("documentSeries/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "documentSeries/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageDocumentSeries({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get particular page
export const getDocumentSeriesById = createAsyncThunk(
  "documentSeries/getDocumentSeriesById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getDocumentSeriesById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create documentSeries
export const createDocumentSeries = createAsyncThunk(
  "documentSeries/createDocumentSeries",
  async (param, { rejectWithValue }) => {
    const { name, documentType, isActive } = param;
    try {
      const body = JSON.stringify({ name, documentType, isActive });
      const { data } = await API.createDocumentSeries(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateDocumentSeries = createAsyncThunk(
  "documentSeries/updateDocumentSeries",
  async (param, { rejectWithValue }) => {
    const { id, values } = param;
    const { name, documentType, isActive } = values;
    try {
      const body = JSON.stringify({ name, documentType, isActive });
      const { data } = await API.updateDocumentSeries(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("documentSeries/handleSearch", async (param, { rejectWithValue }) => {
  const { search, rowsPerPage } = param;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
